/* globals Routes */
// @flow
import React from 'react'

type Props = {
  service: string,
  serviceName: string
}

export default class UnlinkedServiceRow extends React.Component<Props> {
  render () {
    const linkHref = Routes.link_identity_profile_path({provider: this.props.service})

    return (
      <div>
        {`Not linked with ${this.props.serviceName}`}
        <a
          className='link identity-link'
          href={linkHref}
        >
          Link
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/ConnectedServices/UnlinkedServiceRow.js